import { Helmet } from 'react-helmet';

import Navbar from '../components/Navbar/Navbar';
import DynoPrivacyBody from '../components/DynoPrivacyBody';
import Contact from '../components/Mainpage/Contact';
 
import './App.css';

function DynoPrivacy() {
  return (
    <div style={{ 
      position: 'relative', 
      minHeight: '100vh',
      minHeight: 'calc(var(--vh, 1vh) * 100)'
    }}>
      <div style={{
        backgroundColor: 'black',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '-1000',
        pointerEvents: 'none', // Allow clicks to pass through to content
      }}></div>
      <div style={{
        border: '16px solid black',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: '1005',
        pointerEvents: 'none', // Allow clicks to pass through to content
      }}></div>
      <div style={{paddingRight: '16px', paddingLeft: '16px'}}>
        <Helmet>
          <title>{ "ByloByte | Dyno | Privacy" }</title>
          <meta name='description' content= 'Learn about our privacy policy at ByloByte | Dyno. We are committed to protecting your data in how we collect, use, and secure your information.'/>
        </Helmet>

        <Navbar/>
        <DynoPrivacyBody />
        <Contact/>
      </div>
      <div style={{
        position: 'fixed',
        top: '100vh',
        width: '100%',
        height: '200px',
        backgroundColor: 'black',
        zIndex: '1005',
      }}></div>
    </div>
  );
}

export default DynoPrivacy;
